import { gql } from "@apollo/client";

/**
 * GraphQL Query - Infrastructure layer
 * Fetch paginated admin users (and their organizations) for Users & Access.
 */
export const GET_USERS = gql`
  query Users(
    $page_number: Int!
    $page_size: Int!
    $search: String
  ) {
    users(
      params: {
        page_number: $page_number
        page_size: $page_size
        search: $search
      }
    ) {
      total
      page
      limit
      totalActiveCount
      items {
        userId
        authId
        firstName
        lastName
        email
        isActive
        isBot
        kind
        isDeleted
        organizations {
          organizationId
          organizationName
        }
      }
    }
  }
`;

